/**
 * Chatbot Utility Functions
 * 
 * Common utilities for chatbot operations including validation, transformation, etc.
 */

/**
 * Validates if a string is a valid UUID
 */
export const isValidUUID = (uuid: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

/**
 * Validates and returns chatbot ID if valid, otherwise undefined
 */
export const validateChatbotId = (id: string | undefined): string | undefined => {
  if (!id) return undefined;
  if (id.includes('00000000-0000-0000-0000-0000000000')) return id // TODO seed IDs
  return isValidUUID(id) ? id : undefined;
};




